<template>
  <v-card class="overflow-hidden">
    <v-navigation-drawer v-model="drawer" app temporary class="primary">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title white--text">
            Navigation
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list nav dense>
        <v-divider dark />

        <v-list-item-group v-if="
          valideTypeClient('TITULAIRE_POUR_REVENTE') &&
          this.$store.getters.currentUser.clientData
            .indCommandeTPAutorise == true &&
          isPeutEffectuerCommandeTP == true
        ">
          <v-list-item active-class="secondary white--text">
            <v-list-item-content>
              <v-list-item-title class="mt-6 white--text">COMMANDES</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="connecte" active-class="secondary white--text" @click="afficherCreerCommande()">
            <v-list-item-icon>
              <v-icon class="white--text">shopping_cart</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Ma commande</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'historique' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">history</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Historique des commandes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'agent' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">list_alt</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Mes agents</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'favoris' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">list_alt</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Mes listes de favoris</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'representantLogiciel' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">list_alt</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Mon fournisseur logiciel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item active-class="secondary white--text" :to="{ name: 'rechercheTP' }">
            <v-list-item-icon>
              <v-icon class="white--text">search</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">Recherche de commandes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item active-class="secondary white--text" :to="{ name: 'factures' }">
            <v-list-item-icon>
              <v-icon class="white--text">receipt_long</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">Mes factures</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!--
          <v-list-item active-class="secondary white--text" :to="{ name: 'rapports' }">
            <v-list-item-icon>
              <v-icon class="white--text">wysiwyg</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">Mes rapports</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          -->

          <v-list-item active-class="secondary white--text" :to="{ name: 'gererCarte' }">
            <v-list-item-icon>
              <v-icon class="white--text">credit_card</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">Gérer mes cartes de crédit</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!--
          <v-list-item
            active-class="secondary white--text"
            :to="{ name: 'retourMarchandise' }"
          >
            <v-list-item-icon>
              <v-icon class="white--text">assignment_return</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text"
                >Mes retours</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
-->
        </v-list-item-group>

        <v-list-item-group v-else>
          <v-list-item v-if="valideTypeClient('TITULAIRE_POUR_REVENTE')" :to="{ name: 'agent' }"
            active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">list_alt</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Mes agents</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="valideTypeClient('TITULAIRE_POUR_REVENTE')" :to="{ name: 'historique' }"
            active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">history</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Historique des commandes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="valideTypeClient('TITULAIRE_POUR_REVENTE')" :to="{ name: 'factures' }"
            active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">receipt_long</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">Mes factures</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="valideTypeClient('TITULAIRE_POUR_REVENTE')" :to="{ name: 'representantLogiciel' }"
            active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">list_alt</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Mon fournisseur logiciel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item active-class="secondary white--text" :to="{ name: 'gererCarte' }">
            <v-list-item-icon>
              <v-icon class="white--text">credit_card</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">Gérer mes cartes de crédit</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-list-item-group v-if="
          currentUser != null &&
          currentUser.clientData.indDemandeIPAutorise == true
        ">
          <v-list-item active-class="secondary white--text">
            <v-list-item-content>
              <v-list-item-title class="white--text pt-10">IMPORTATIONS PRIVÉES</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="
            currentUser != null &&
            currentUser.clientData != null &&
            currentUser.clientData.indCapaciteFinanciere == true
          " :to="{ name: 'capaciteFinanciere' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">monetization_on</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Capacité financière</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item active-class="secondary white--text" @click="afficherCreerDemandeIP()">
            <v-list-item-icon>
              <v-icon class="white--text">list_alt</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Créer une demande</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'historiqueDemande' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">list_alt</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Historique des demandes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'rechercheDemande' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">search</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Rechercher des demandes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'fournisseur' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">description</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Mes fournisseurs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'rapports' }" active-class="secondary white--text">
            <v-list-item-icon>
              <v-icon class="white--text">wysiwyg</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Mes rapports</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <v-divider class="hidden-md-and-up" dark />

        <v-list-item-group class="hidden-md-and-up">
          <v-list-item active-class="secondary white--text" :to="{ name: 'profilEdit' }">
            <v-list-item-icon>
              <v-icon class="white--text">account_box</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="white--text">Mon profil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="primary white--text" @click="logout()">
            <v-list-item-icon>
              <v-icon class="white--text">power_settings_new</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title class="white--text">Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app class="primary">
      <v-app-bar-nav-icon v-if="connecte" class="theme--dark" @click.stop="drawer = !drawer">
        <v-flex xs10 pl-10>
          <v-toolbar-title style="font-size: 14px;">Menu</v-toolbar-title>
        </v-flex>
        <v-icon class="theme--dark">mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <v-flex xs10 pl-10>
        <!-- Force GET request on index.html on logo click -->
        <v-btn text onclick="window.location.href = '/accueil'">
          <v-img src="@/assets/SAQ_white.png" contain max-width="100" />
        </v-btn>
      </v-flex>
      <v-spacer />

      <v-btn v-if="
        connecte &&
        this.$store.getters.currentUser.clientData.indCommandeTPAutorise ==
        true &&
        isPeutEffectuerCommandeTP == true
      " text active-class="secondary" class="white--text text-none mx-1 px-2" @click="afficherCreerCommande()">
        <v-icon text class="pr-1">shopping_cart</v-icon>
        <v-badge :content="nbProduitsDansMaCommande" color="accent">
          <span class="text-subtitle-2">Ma commande</span>
        </v-badge>
      </v-btn>

      <v-btn v-if="connecte" :to="{ name: 'profilEdit' }" text active-class="secondary"
        class="white--text text-none hidden-sm-and-down ml-3">
        <v-icon text class="pr-1">account_box</v-icon>
        <span class="text-subtitle-2" style="text-decoration: underline; color: white">Bonjour, {{ nom }}</span></v-btn>

      <!--
        <v-btn icon>
          <v-icon v-if="!francais" color="white" @click="changeLocale('fr')"
            >language</v-icon
          >
          <v-icon v-else color="white" @click="changeLocale('en')"
            >language</v-icon
          >
        </v-btn>-->

      <v-btn icon class="hidden-sm-and-down">
        <v-icon v-if="connecte" color="white" @click="logout()">power_settings_new</v-icon>
      </v-btn>
    </v-app-bar>
  </v-card>
</template>

<script>
import i18n from '@/plugins/i18n';
export default {
  name: 'Entete',

  data: () => ({
    drawer: false
  }),

  computed: {
    francais: function() {
      return i18n.locale === 'fr'
    },
    connecte: function() {
      console.log('connecte=' + this.$store.getters.estAuthentifie)
      return this.$store.getters.estAuthentifie
    },
    currentUser: function() {
      return this.$store.getters.currentUser
    },
    nom: function() {
      return this.$store.getters.usagerConnecteInfosJDE.nom
    },
    nbProduitsDansMaCommande() {
      // Has to be a String
      return this.$store.getters.commande.nbBouteilles.toString()
    },
    isPeutEffectuerDemande() {
      if (
        this.currentUser != null &&
        this.currentUser.clientData != null &&
        this.currentUser.clientData.indDemandeIPAutorise == true
      ) {
        return true
      } else {
        return false
      }
    },

    isPeutEffectuerCommandeTP() {
      if (
        this.currentUser != null &&
        this.currentUser.clientData != null &&
        this.$store.getters.currentUser.clientData.instructionLivraisonTPData !=
        null &&
        this.$store.getters.currentUser.clientData.instructionLivraisonTPData
          .dtInactivite == null &&
        this.$store.getters.currentUser.infosClientJDE.codeBlocage.length ==
        0 &&
        (this.$store.getters.usagerConnecteInfosJDE.modePaiement == 7 ||
          this.$store.getters.usagerConnecteInfosJDE.modePaiement == '')
        // Le mode de paiement recu du carnet d'adresse de JDE doit être
        // soit 7 ou à blanc
      ) {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    group() {
      this.drawer = false
    }
  },

  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    changeLocale(locale) {
      i18n.locale = locale
      this.$vuetify.lang.current = locale
    },
    afficherCreerCommande() {
      this.$router.push({ name: 'commandeTP' })
    },
    gererCarte() {
      this.$router.push({ name: 'gererCarte' })
    },
    afficherCreerDemandeIP() {
      this.$router.push('/', () => { })
      this.$router.push({ name: 'demandeIP' })
    },
    versPageLogin() {
      this.$router.push({ name: 'profilEdit' })
    },
    valideTypeClient(type) {
      return this.$store.getters.valideTypeClient(type)
    },

    // Temporaire. validation pour l'affichage des factures, c'est seulement
    // pour la phase de tests, on debute avec 34 clients
    validerNoClientJDE(noClientJDE) {
      if (
        noClientJDE == '14880300' ||
        noClientJDE == '15148170' ||
        noClientJDE == '17472199' ||
        noClientJDE == '3506203' ||
        noClientJDE == '141913' ||
        noClientJDE == '14648533' ||
        noClientJDE == '6119007' ||
        noClientJDE == '175950' ||
        noClientJDE == '9041858' ||
        noClientJDE == '16882913' ||
        noClientJDE == '116502' ||
        noClientJDE == '14600676' ||
        noClientJDE == '110691' ||
        noClientJDE == '111304' ||
        noClientJDE == '130163' ||
        noClientJDE == '140750' ||
        noClientJDE == '150341' ||
        noClientJDE == '153923' ||
        noClientJDE == '173034' ||
        noClientJDE == '176132' ||
        noClientJDE == '2703132' ||
        noClientJDE == '5008433' ||
        noClientJDE == '5565644' ||
        noClientJDE == '6030001' ||
        noClientJDE == '6359271' ||
        noClientJDE == '6465183' ||
        noClientJDE == '6643181' ||
        noClientJDE == '7260610' ||
        noClientJDE == '7467027' ||
        noClientJDE == '8166239' ||
        noClientJDE == '9668789' ||
        noClientJDE == '10768919' ||
        noClientJDE == '12386482' ||
        noClientJDE == '13930186' ||
        noClientJDE == '16588237' ||
        noClientJDE == '110076' ||
        noClientJDE == '16347840'
      ) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
.theme--dark.v-divider {
  border-color: rgba(255, 255, 255, 0.623) !important;
}
</style>
